import {
    StepDisabledStates,
    StepTouchedStates,
    StepValidityStates,
    StepVisibilityStates
} from './step-indicator-item.viewmodel';

export class StepModel {
    constructor(
        public readonly stepId: string,
        public readonly title: string,
        public readonly disabledState: StepDisabledStates = StepDisabledStates.disabled,
        public readonly validity: StepValidityStates = StepValidityStates.invalid,
        public readonly touchedState: StepTouchedStates = StepTouchedStates.untouched,
        public readonly visibility: StepVisibilityStates = StepVisibilityStates.visible,
        public readonly numberOfErrors: number = 0
    ) {}
}
